import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';


export class AreaAtuacaoProcessoFilter {
  descricao = '';

  pagina = 0;
  itensPorPagina = 5;
}

export class AssuntoAtendimentoFilter {
  descricao = '';

  pagina = 0;
  itensPorPagina = 5;
}

export class AssuntoCnjFilter {
  id = 0;
  codItem = '';
  nome = '';

  pagina = 0;
  itensPorPagina = 5;
}

export class FaseProcessoFilter {
  id = 0;
  descricao = '';

  pagina = 0;
  itensPorPagina = 5;
}

export class TribunalFilter {
  id = 0;
  descricao = '';

  pagina = 0;
  itensPorPagina = 5;
}

export class OrgaoJulgadorFilter {
  id = 0;
  descricao = '';

  pagina = 0;
  itensPorPagina = 5;
}

export class PrazoProcessoFilter {
  pagina = 0;
  itensPorPagina = 3;
}

export class MovimentoProcessoFilter {
  id = 0;

  pagina = 0;
  itensPorPagina = 10;
}


@Injectable({
  providedIn: 'root'
})
export class JuridicoService {

  urlListProcessos = ''
  urlProcesso = ''

  constructor(
    private httpCliente: HttpClient
  ) {
    this.urlListProcessos = `${environment.apiUrl}/processos`;
    this.urlProcesso = `${environment.apiUrl}/processos`;
  }

  buscarListaProcessosPorIdSocio(idSocio: number, token: any) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    }
    return this.httpCliente.get(`${this.urlListProcessos}/${idSocio}`, httpHeaders);
  }

  buscarProcessoPorId(idProcesso: number, token: any) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    }
    return this.httpCliente.get(`${this.urlProcesso}/${idProcesso}`, httpHeaders);
  }

  buscarProcessoPorIdComMovimentacao(id: number, token: string) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    };
    return this.httpCliente.get(`${this.urlProcesso}/processos-autor/${id}`, httpHeaders);
  }

  pesquisarSocioDependenteProcesso(idSocioDependente: number, tipoSocio: string, token: string) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    };
    return this.httpCliente.get(`${this.urlProcesso}/processo-atendimento/${idSocioDependente}/${tipoSocio}`, httpHeaders)
  }

  ultimoTelefoneAtendimento(idSocioDependente: number, token: string) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    }
    return this.httpCliente.get(`${this.urlProcesso}/atendimentos-ultimo-telefone/2/${idSocioDependente}`, httpHeaders);
  }

  grupoProcessoListar(token: any) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    }
    return this.httpCliente.get(`${this.urlProcesso}/grupos-processos`, httpHeaders);
  }

  pesquisarAreaAtuacaoProcesso(token: any) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    }
    return this.httpCliente.get(`${this.urlProcesso}/area-atuacao`, httpHeaders);
  }

  fasesProcessosListar(token: any) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    }
    return this.httpCliente.get(`${this.urlProcesso}/fases-processos`, httpHeaders);
  }

  tribunaisListar(token: any) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    }
    return this.httpCliente.get(`${this.urlProcesso}/tribunais`, httpHeaders);
  }

  orgaosJulgadoresListar(token: any) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    }
    return this.httpCliente.get(`${this.urlProcesso}/orgaos-julgadores`, httpHeaders);
  }

  instanciasListar(token: any) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    }
    return this.httpCliente.get(`${this.urlProcesso}/instancias`, httpHeaders);
  }

  buscarAssuntoPorId(idAssunto: number, token: any){
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    }
    return this.httpCliente.get(`${this.urlProcesso}/assuntos/${idAssunto}`, httpHeaders);
  }

  buscarClasseProcessualPorId(idClasseProcessual: number, token: any){
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    }
    return this.httpCliente.get(`${this.urlProcesso}/classes-processuais/${idClasseProcessual}`, httpHeaders);
  }

  buscrarMovimentacaoesPorIDProcesso(descricaoProcessoFilter: MovimentoProcessoFilter, tipoPessoa: string, token: string) {
    const httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }),
      params: new HttpParams()
        .set('page', descricaoProcessoFilter.pagina.toString())
        .set('size', descricaoProcessoFilter.itensPorPagina.toString())
        .set('id', descricaoProcessoFilter.id.toString())
    };
    if (tipoPessoa != 'C') {
      return this.httpCliente.get(`${this.urlProcesso}/movimentacoes-processo`, httpHeaders);
    } else {
      return this.httpCliente.get(`${this.urlProcesso}/movimentacoes-processo-agregado`, httpHeaders);
    }
  }

}
